import React, { useMemo, useEffect, ChangeEvent } from 'react';
import cx from 'classnames';
import './styles.css';

import { UseFormReturn, useFormContext } from 'react-hook-form';

export type RadioBoxOptionProps<T> = Omit<
  JSX.IntrinsicElements['input'],
  'value' | 'onChange'
> & {
  value: T;
  name?: string;
  isToggle?: boolean;
  isLengthToggle?: boolean;
  isRightToggle?: boolean;
  children?: React.ReactNode;
  register?: UseFormReturn['register'];
  setValue?: UseFormReturn['setValue'];
  onChange?(event: ChangeEvent<HTMLInputElement>, value: T): void;
};

let uniqueId = 0;
const createUniqueId = () => `radio-option-${uniqueId++}`;

const RadioBoxOption = <T extends any>({
  children,
  name,
  value,
  onChange,
  className,
  isToggle = false,
  isLengthToggle = false,
  isRightToggle = false,
  ...rest
}: RadioBoxOptionProps<T>) => {
  const { register } = useFormContext() || {};
  const id = useMemo(() => createUniqueId(), []);
  const classNames = cx('relative outline-none', className);

  useEffect(() => {
    register?.(name!);
  }, [register, name]);

  return (
    <label
      className={classNames}
      style={isToggle ? { paddingLeft: 0 } : {}}
      htmlFor={id}
    >
      <input
        id={id}
        //ref={register}
        type='radio'
        name={name}
        className='tim--radio-box absolute -z-1 opacity-0 outline-none'
        value={value as string}
        onChange={(e) => onChange?.(e, value)}
        {...rest}
      />
      <span
        className={cx(
          'min-w-10 flex h-full w-full cursor-pointer select-none items-center justify-center rounded border border-tim-primary bg-white px-3 py-2 text-sm font-medium text-tim-primary transition duration-200 hover:bg-gray-200',
          {
            'rounded-r-none': isToggle && isLengthToggle,
            'rounded-l-none': isToggle && isRightToggle,
            'disable-payment-options': rest.disabled,
          },
        )}
      >
        {children}
      </span>
    </label>
  );
};

export default RadioBoxOption;
